import { AxiosResponse } from 'axios'
import {
	IHttpGetMethod,
	IRequestHeaders,
} from '../../@core/@shared/domain/interfaces/IHttpClient.interface'
import { HttpStatusCodeEnum } from '../../@core/@shared/domain/enums/HttpStatusCode.enum'
import PromiseResolver from '../../@core/@shared/domain/providers/PromiseResolver.proveider'
import { StaticDashboardAgilityData } from './DashboardAgility.data'

export abstract class DashboardAgilityClient implements IHttpGetMethod {
	abstract get(url: string, headers?: IRequestHeaders): Promise<AxiosResponse>
}

export class StaticDashboardAgilityClient extends DashboardAgilityClient {
	constructor(private _httpStatus: HttpStatusCodeEnum) {
		super()
	}

	get(): Promise<AxiosResponse> {
		if (this._httpStatus !== HttpStatusCodeEnum.Ok) {
			const response = { status: this._httpStatus, data: undefined } as AxiosResponse
			return PromiseResolver.resolve(response)
		}

		const response = {
			status: this._httpStatus,
			data: StaticDashboardAgilityData.item,
		} as AxiosResponse
		return PromiseResolver.resolve(response)
	}
}
